import Inline from '@commercetools-uikit/spacings-inline';
import Inset from '@commercetools-uikit/spacings-inset';
import InsetSquish from '@commercetools-uikit/spacings-inset-squish';
import Stack from '@commercetools-uikit/spacings-stack';

const Spacings = {
  Inline,
  Inset,
  InsetSquish,
  Stack
};
var Spacings$1 = Spacings;

export { Spacings$1 as default };
